import { render, staticRenderFns } from "./StudentAdd.vue?vue&type=template&id=bdd82ce6&"
import script from "./StudentAdd.vue?vue&type=script&lang=js&"
export * from "./StudentAdd.vue?vue&type=script&lang=js&"
import style0 from "./StudentAdd.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StudentAdd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports